
















import { Component, Mixins } from 'vue-property-decorator'

import AppConfirmModal from '@/components/AppConfirmModal.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import { ADD_USER_MEDIA } from '@/gql/user'
import { Upload, Common } from '@/mixins'

@Component({
  components: {
    AppConfirmModal,
    AppTitleBar
  }
})
export default class extends Mixins(Common, Upload) {
  isModalActive = false

  async onChangeFile (e: { target: { files: File[] }}) {
    await this.showLoading()
    try {
      const filename = await this.uploadFile(e.target.files[0], {
        mediaType: 'IMAGE',
        mediaOwnerType: 'USER',
        mediaOwnerUseType: 'USER_ID'
      })

      await this.$apollo.mutate({
        mutation: ADD_USER_MEDIA,
        variables: {
          input: {
            filename,
            mediaType: 'IMAGE',
            mediaOwnerUseType: 'USER_ID'
          }
        }
      })
      this.isModalActive = true
    } finally {
      await this.dismissLoading()
    }
  }
}
